import styled from "@emotion/styled";

import Button from "metabase/core/components/Button";

export const NewCollectionButton = styled(Button)`
  margin-top: 0.5rem;
`;
